import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios"

import { EmailContentLogType } from "api/emailCommunication/getEmailCommunicationDetailApi"

export interface EmailCommunicationType {
  bookingNumber: string
  emailCommunicationId: string
  from: string | null
  to: string | null
  cc: string | null
  subject: string | null
  content: string | null
  attachments: string[]
  toResolvedProxy: string | null
  fromProxy: string | null
  createdDt: number | null
  status: string | null
  sender: string | null
  recipient: string | null
  text: string | null
  errorMessage: string | null
}

interface GetEmailCommunicationDetailResponseData extends AxiosResponse {
  apiStatus: string
  data: EmailCommunicationType
}

interface GetEmailCommunicationDetailResponse extends AxiosResponse {
  data: GetEmailCommunicationDetailResponseData
}

export interface GetEmailCommunicationDetailRequest
  extends Partial<AxiosRequestConfig> {
  emailCommunicationId: string
}

export function getEmailLogDetailApi(
  { emailCommunicationId, ...config }: GetEmailCommunicationDetailRequest,
  axiosInstance: AxiosInstance,
): Promise<GetEmailCommunicationDetailResponse> {
  return axiosInstance({
    method: "get",
    url: `newadmin/email-log/${emailCommunicationId}`,
    ...config,
  })
}
